var map = {
	"./DE.svg": 50390,
	"./EE.svg": 3124,
	"./EN.svg": 63386,
	"./ES.svg": 33803,
	"./FR.svg": 85954,
	"./RU.svg": 72077,
	"./TR.svg": 44268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24166;